import { useNavigate } from "react-router-dom";

function useCustomNavigate() {
  const navigate = useNavigate();

  return (path, options = {}, event = window.event) => {
    try {
      if (event?.ctrlKey || event?.metaKey) {
        const url = new URL(path, window.location.origin);
        window.open(url.toString(), "_blank");
      } else {
        navigate(path, options);
      }
    } catch (err) {
      console.error("Navigation error:", err);
    }
  };
}

export default useCustomNavigate;
